import { useBranding } from '../branding/BrandingProvider';

/** Marka bloğu (logo + uygulama adı). Kabuk ve login ekranında ortak kullanılır. */
export function Brand({ variant }: { variant: 'shell' | 'auth' }) {
  const { branding } = useBranding();
  const cls = variant === 'shell' ? 'shell-brand' : 'auth-brand';
  const letter = (branding.appName || 'P').trim().charAt(0).toUpperCase() || 'P';
  return (
    <div className={cls}>
      {branding.logo ? (
        <span className="brand-logo brand-logo-img">
          <img src={branding.logo} alt={branding.appName} />
        </span>
      ) : (
        <span className="brand-logo">{letter}</span>
      )}
      <span>{branding.appName}</span>
    </div>
  );
}
